import moment from "moment";
import numeral from "numeral";

import { CaretDownOutlined, CaretUpOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

export const getDataRows = (reportData) => {
  const dataRange = reportData?.map((data) => {
    return {
      key: data?.id,
      branch: data?.branch,
      shopId: data?.shopId,
      date: data?.date,
      income: data?.totalIncome,
      receivable_income: data?.totalReceivable,
      status: data?.status,
      // difference: data?.difference,
      difference: data?.totalIncome-data?.totalReceivable,

    };
  });
  return dataRange;
};

export const getHeaderRows = () => {
  const columns = [
    {
      title: "Branch",
      dataIndex: "branch",
      key: "branch",
      align: "center",
      defaultsortorder: "descend",
      render: (value) => <div style={{ textAlign: "left" }}>{value}</div>,
      sorter: {
        compare: (a, b) => a.branch.localeCompare(b.branch),
        multiple: 2,
      },
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      align: "center",
      defaultsortorder: "descend",
      render: (value) => {
        return moment(value?.toDate()).format("DD/MM/YYYY");
      },
      sorter: {
        compare: (a, b) => a.date - b.date,
        multiple: 1,
      },
    },
    {
      title: "Income ($)",
      dataIndex: "income",
      key: "income",
      align: "center",
      width: 220,
      render: (value) => {
        return (
          <div style={{ textAlign: "right", paddingRight: 60 }}>
            {numeral(value).format("0,0.00")}
          </div>
        );
      },
      defaultsortorder: "descend",
      sorter: {
        compare: (a, b) => a.income - b.income,
        multiple: 1,
      },
    },
    {
      title: "Receivable Income ($)",
      dataIndex: "receivable_income",
      key: "receivable_income",
      align: "center",
      width: 220,
      render: (value) => {
        return (
          <div style={{ textAlign: "right", paddingRight: 60 }}>
            {numeral(value).format("0,0.00")}
          </div>
        );
      },
      defaultsortorder: "descend",
      sorter: {
        compare: (a, b) => a.receivable_income - b.receivable_income,
        multiple: 1,
      },
    },
    {
      title: "Difference",
      dataIndex: "difference",
      key: "difference",
      align: "center",
      width: 220,
      render: (value) => getDifference(value),
      defaultsortorder: "descend",
      sorter: {
        compare: (a, b) => a.difference - b.difference,
        multiple: 1,
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      align: "center",
      render: (value) => {
        return getStatus(value);
      },
      defaultsortorder: "descend",
      sorter: {
        compare: (a, b) => a.status.localeCompare(b.status),
        multiple: 2,
      },
    },
  ];
  return columns;
};

const getDifference = (number) => {
  const renderIcon = number >= 0 ? <CaretDownOutlined /> : <CaretUpOutlined />;
  if (Math.abs(number) <= 100) {
    return (
      <div style={{ color: "green" }}>
        <div style={{ textAlign: "right", paddingRight: 60 }}>
          {renderIcon} {numeral(Math.abs(number)).format("0,0.00")}
        </div>
      </div>
    );
  } else {
    return (
      <div style={{ color: "red" }}>
        <div style={{ textAlign: "right", paddingRight: 60 }}>
          {renderIcon} {numeral(Math.abs(number)).format("0,0.00")}
        </div>
      </div>
    );
  }
};

const getStatus = (value) => {
  return value?.toLowerCase() === "confirmed" ? (
    <div style={{ color: "green" }}>Confirmed</div>
  ) : (
    <div style={{ color: "red" }}>To be confirmed</div>
  );
};
